import Controller from '../abstracts/Controller';
import 'scss-templates/t-unsubscribe.scss';

export default class MyAccountPrivacyController extends Controller {
  static get COMPONENTS(){
    return [
      'PrivacyUnsubscribeComponent'
    ];
  }

}
